import { createFeatureSelector, createSelector } from "@ngrx/store";
import { itemConfigurationHeaderFeatureKey, LineItemState, scheduleLineItemFeatureKey, itemConfigurationPerformanceFeatureKey, itemConfigurationPricingFeatureKey, ProjectScheduleLineItemState } from "./item-configuration.reducer";
import { ItemConfigurationHeaderViewModel } from "src/app/models/config-view-models";
import { ProjectScheduleLineItemPricing } from "src/app/models/pricing-view-models";

export const selectItemConfigurationHeaderState = createFeatureSelector<ItemConfigurationHeaderViewModel>(itemConfigurationHeaderFeatureKey);
export const selectLineItemState = createFeatureSelector<LineItemState>(scheduleLineItemFeatureKey);
export const selectPerformanceLineItemState = createFeatureSelector<ProjectScheduleLineItemState>(itemConfigurationPerformanceFeatureKey);
export const selectPricingLineItemState = createFeatureSelector<ProjectScheduleLineItemPricing>(itemConfigurationPricingFeatureKey);
export const initialLineItemSelectorState = createFeatureSelector<LineItemState>(scheduleLineItemFeatureKey);

export const selectItemConfigurationHeader = createSelector(
  selectItemConfigurationHeaderState,
  (state: ItemConfigurationHeaderViewModel) => {
    let rtn = {...state, 
      ProductTypeId: state.ProductTypeId, 
      ProductType: state.ProductType,
      ProductTypeCategoryId: state.ProductTypeCategoryId,
      ProductTypeCategory: state.ProductTypeCategory, 
      ProductModelClassId: state.ProductModelClassId,
      ProductModelClass: state.ProductModelClass,
      ProductModelId: state.ProductModelId,
      ProductModel: state.ProductModel,  
      ItemTag: state.ItemTag,
      ItemQty: state.ItemQty
    };
    
    return rtn;
  }
);

export const selectLineItemId = createSelector(
  selectLineItemState,
  (state: LineItemState) => {
    let rtn = state;// {...state, ProductTypeId: state.ProductTypeId, ProductTypeCategoryId: state.ProductTypeCategoryId, ProductModelClassId: state.ProductModelClassId, ProductModelId: state.ProductModelId};
    //console.log('selectLineItemId', rtn.LineItemId);
    return rtn;
  }
);
export const selectPerformanceLineItem = createSelector(
  selectPerformanceLineItemState,
  (state: ProjectScheduleLineItemState) => {
    let rtn = state;// {...state, ProductTypeId: state.ProductTypeId, ProductTypeCategoryId: state.ProductTypeCategoryId, ProductModelClassId: state.ProductModelClassId, ProductModelId: state.ProductModelId};
    //console.log('selectPerformanceLineItem', rtn);
    return rtn;
  }
);